import { AcademySearchSource } from './enums/searchSource.enum'

export const SEARCH_HIGHLIGHT_QUERY_PARAM = 'highlight'

export const SEARCH_RATE_LIMIT_MAX = 120

export const SEARCH_RATE_LIMIT_WINDOW_MS = 60_000

export const SEARCH_RESULT_LIMIT = 40

export const SEARCH_CANDIDATE_LIMIT = 160

export const SEARCH_COUNT_LIMIT = 12

export const SEARCH_FIELD_BOOST = {
  title: 4,
  description: 2,
  categoryDisplay: 1.5,
  body: 1,
} as const

export const ACADEMY_SEARCH_SOURCE_ORDER: readonly AcademySearchSource[] = [
  AcademySearchSource.QuickStart,
  AcademySearchSource.Documentation,
  AcademySearchSource.Glossary,
]

export const SNIPPET_ANCHOR_SKIP_WORDS = [
  'a',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'been',
  'being',
  'both',
  'but',
  'by',
  'did',
  'do',
  'does',
  'doing',
  'done',
  'few',
  'for',
  'from',
  'how',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'many',
  'me',
  'my',
  'no',
  'not',
  'of',
  'on',
  'or',
  'our',
  'so',
  'some',
  'the',
  'their',
  'them',
  'they',
  'to',
  'via',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'who',
  'whom',
  'whose',
  'why',
  'with',
  'you',
  'your',
] as const
